import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IExamPaperStudentAnswer,
  IGetExamPaperData,
  IGetExamPaperParam,
  IGetExamParam,
  ISubmitExamPaperStudentAnswer,
} from "src/services/exam/exam.model";
import examService from "src/services/exam/exam.service";

export const getExamPaperDetails = createAsyncThunk(
  "student/getExamPaperDetails",
  async (data: IGetExamParam) => {
    return examService.getExamPaperDetails(data.admissionId, data.batch_id);
  }
);

export const getExamPaperDetailsByExamPaperId = createAsyncThunk(
  "student/getExamPaperDetailsByExamPaperId",
  async (data: IGetExamPaperParam) => {
    return examService.getExamPaperDetailsByExamPaperId(
      data.exam_paper_id,
      data.admission_id
    );
  }
);

export const AddExamPaperStudentAnswer = createAsyncThunk(
  "student/AddExamPaperStudentAnswer",
  async (data: IExamPaperStudentAnswer) => {
    return examService.AddExamPaperStudentAnswer(data);
  }
);

export const submitExamPaperStudentAnswer = createAsyncThunk(
  "student/submitExamPaperStudentAnswer",
  async (data: ISubmitExamPaperStudentAnswer) => {
    return examService.submitExamPaperStudentAnswer(data);
  }
);

export const getExamResultDetails = createAsyncThunk(
  "student/getExamResultDetails",
  async (data: { admission_id: number; package_id: number }) => {
    return examService.getExamResultDetails(data);
  }
);

export const examPaperQuestion = createAsyncThunk(
  "student/examPaperQuestion",
  async (data: IGetExamPaperData) => {
    return examService.examPaperQuestion(data);
  }
);
